import { createContext, useCallback, useContext, useState, ReactNode } from 'react';

interface TrackedCampaign {
  campaignId: string;
  name: string;
  expectedTotal?: number;
}

interface CampaignProgressContextValue {
  tracked: TrackedCampaign | null;
  startTracking: (campaign: TrackedCampaign) => void;
  stopTracking: () => void;
}

const CampaignProgressContext = createContext<CampaignProgressContextValue>({
  tracked: null,
  startTracking: () => {},
  stopTracking: () => {},
});

export function CampaignProgressProvider({ children }: { children: ReactNode }) {
  const [tracked, setTracked] = useState<TrackedCampaign | null>(null);

  const startTracking = useCallback((campaign: TrackedCampaign) => {
    setTracked(campaign);
  }, []);

  const stopTracking = useCallback(() => setTracked(null), []);

  return (
    <CampaignProgressContext.Provider value={{ tracked, startTracking, stopTracking }}>
      {children}
    </CampaignProgressContext.Provider>
  );
}

export function useCampaignProgressTracker() {
  return useContext(CampaignProgressContext);
}
